import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './Homepage.module.scss'
import { getShortcutsMenuList } from '../helpers'
import useQA from 'hooks/useQA'

const ShortcutsSubMenu: FC = () => {
  const { testId } = useQA()

  return (
    <div className={styles.shortcutsSubMenu} {...testId('shortcuts-sub-menu')}>
      {getShortcutsMenuList().map((item, index) => (
        <button
          type='button'
          key={index}
          onClick={() =>
            window &&
            window.dataLayer.push({
              event: 'shortcuts_menu',
              label: item.title,
            })
          }
        >
          <SALink href={item.link} title={item.title}>
            <p>{item.title}</p>
          </SALink>
        </button>
      ))}
    </div>
  )
}

export default ShortcutsSubMenu
